import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux';
import swal from "sweetalert";
import { fetchVoucherOffers, updateVoucherOffer } from '../../../Redux/Slices/voucherOffersSlice';
import { useProperty } from '../../../PropertyContext';

export const EditVoucherOffer = ({ offerData }) => {
    const dispatch = useDispatch();
    const { selectedProperty } = useProperty();
    const [loading, setLoading] = useState(false);
    const [formData, setFormData] = useState({
        ID: "",
        Title: "",
        Description: "",
        SortOrder: ""
    });

    // ✅ Prefill form when modal opens
    useEffect(() => {
        if (offerData) {
            setFormData({
                ID: offerData.ID,
                Title: offerData.Title,
                Description: offerData.Description,
                SortOrder: offerData.SortOrder
            });
        }
    }, [offerData]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        setLoading(true);

        try {

            const resultAction = await dispatch(updateVoucherOffer(formData));

            if (updateVoucherOffer.fulfilled.match(resultAction)) {

                // ✅ Fresh data reload
                await dispatch(fetchVoucherOffers(selectedProperty.PropertyID));

                swal("Success!", "Voucher updated successfully!", "success");

                // ✅ Close modal
                document.querySelector('#Edit-Voucer-Offer .btn-close').click();

            } else {
                swal("Error!", "Update failed!", "error");
            }

        } catch (error) {
            swal("Error!", "Something went wrong!", "error");
        } finally {
            setLoading(false);
        }
    };


    return (
        <>
            {loading && (
                <div className="fullscreen-loader">
                    <div className="fas fa-spinner fa-spin fa-3x " role="status"></div>
                </div>
            )}
            <form onSubmit={handleSubmit}>
                <div className="row">

                    <div className="col-md-12 mb-3">
                        <input
                            type="text"
                            name="Title"
                            value={formData.Title}
                            onChange={handleChange}
                            className="form-control"
                            placeholder="Title"
                        />
                    </div>

                    <div className="col-md-12">
                        <textarea
                            rows={2}
                            name="Description"
                            value={formData.Description}
                            onChange={handleChange}
                            className="form-control"
                            placeholder="Description"
                        />
                    </div>

                    <div className="col-md-12">
                        <div className="text-end mt-3">
                            <button type="submit" className="btn btn-primary">
                                Update
                            </button>
                        </div>
                    </div>

                </div>
            </form>
        </>
    )
}
